import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: theme.spacing(8.75),
    height: theme.spacing(12.5),

    '&:hover': {
      cursor: 'pointer',
    },
  },

  content: {
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(8.75),
    minHeight: theme.spacing(8.75),
    backgroundColor: theme.palette.game.carousel.item.background,
  },

  imageContainer: {
    width: theme.spacing(4.375),
    height: theme.spacing(4.375),

    '& img': {
      userSelect: 'none',
      width: '100%',
      height: '100%',
    },
  },

  title: {
    position: 'absolute',
    width: theme.spacing(14.5),
    bottom: theme.spacing(0),

    '&.MuiTypography-root': {
      fontSize: theme.spacing(1.5),
      fontFamily: '"Noto Sans"',
      fontWeight: 600,
      textOverflow: 'ellipsis',
      textAlign: 'center',
    },
  },
}));
